import TemperatureSensorIcon from '@images/icons/sensors/temperature.webp';
import ProximitySensorIcon from '@images/icons/sensors/proximity.webp';
import InfraredSensorIcon from '@images/icons/sensors/infrared.webp';
import UltrasonicSensorIcon from '@images/icons/sensors/ultrasonic.webp';
import LightSensorIcon from '@images/icons/sensors/light.webp';
import TouchSensorIcon from '@images/icons/sensors/touch.webp';
import ColorSensorIcon from '@images/icons/sensors/color.webp';
import HumiditySensorIcon from '@images/icons/sensors/humidity.webp';

export const sensors = [
	{ icon: TemperatureSensorIcon, name: 'Temperature Sensor' },
	{ icon: ProximitySensorIcon, name: 'Proximity Sensors' },
	{ icon: InfraredSensorIcon, name: 'InfraredSensor (IR Sensor)' },
	{ icon: UltrasonicSensorIcon, name: 'Ultrasonic Sensor' },
	{ icon: LightSensorIcon, name: 'Light Sensor' },
	{ icon: TouchSensorIcon, name: 'Touch Sensor' },
	{ icon: ColorSensorIcon, name: 'Color Sensor' },
	{ icon: HumiditySensorIcon, name: 'Humidity Sensor' },
];
